import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {Typeahead} from 'react-bootstrap-typeahead';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class DirectoryDonor extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			start_date:"",
			end_date:"",
			sex:"all",
			states:[],
			estate:"all",
			mpio:"all",
			blood_types:[],
			blood_type:"all",
			donation_types:[],
			donation_type:"all",
			mpios:[{names:'TODOS', key:'all'}],
			mpioSelected:[{names:'TODOS'}],
	      	indice:-1,
	      	isLoading: false,
			group:"all",
	      	rh:"all",
			date_hour:"",
			medical:"",
			filename:'Directorio Donantes',
			columns:[
				{title:'Nombre'},
				{title:'Sexo'},
				{title:'Estado'},
				{title:'Municipio'},
				{title:'Dirección'},
				{title:'Telefono'},
				{title:'Edad'},
				{title:'Grupo & RH'}
			],
			listado:[]
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'donation_type/actives',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({donation_types:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups_level2?type=state_mx&option=parents',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					states:response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					blood_types:response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();

	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		this.$el = $(this.el);
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY") 

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation: 'landscape',
                	//pageSize: 'A3',
                	customize: (doc) => { 
                		var i_table = 3;

                		doc.content.unshift({
							//image: this.props.header_document,
							text:'',
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

            			doc.content[i_table].table.widths=["20%","5%","15%","15%","20%","10%","5%","10%"];
                		doc.styles.tableHeader.fontSize = 7;
                		doc.defaultStyle.fontSize = 7; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 

                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};

                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: false,
			autoWidth: false,
			ordering:true,
			info:false,
		
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	 
	}

	handleChange(e){
		if(e.target !== undefined){
			this.setState({
				[e.target.name]: e.target.value
			});

			if(e.target.name === 'estate'){

				this.setState({
					mpio:e.target.value === 'all' ? 'all' : '', 
					mpioSelected:e.target.value === 'all' ? [{names:'TODOS'}] : []
				});
				if(e.target.value !== 'all'){
					this.getMpios(e.target.value);
				}
				
			}
			if(e.target.value !== ""){
				document.getElementById(e.target.id).classList.remove('error');
			}
		}else{
			if(e.length > 0){
				this.setState({
					mpioSelected:e,
					mpio:e[0].key
				});
			}
		}
	}

	searching(){
		if(this.validSearch()){
			if(this.dateCompare()){

				this.props.waiting.handleShow('Buscando...');

				var object = {};
				object.start_date = this.state.start_date;
				object.end_date = this.state.end_date;
				object.sex = this.state.sex;
				object.donation_type = this.state.donation_type;
				object.estate = this.state.estate;
				object.town = this.state.mpio;
				object.group = this.state.group;
				object.rh = this.state.rh;
				object.health_facilities_id = sessionStorage.getItem('health_facilities_id');

				fetch(Config.default.apiGateway.URL+'reports/directory_donors', {
					method : 'post',
					body:JSON.stringify(object),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				})
				.then(response => {
					
					if (response !== undefined) { 
						var list = [];

						response.map((res)=>{
							list.push([
								res.name,
								res.sex,
								res.estado,
								res.municipio,
								res.calle,
								res.phone,
								res.age,
								res.grupo_rh
							])
						})
						
						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							
						});
					}
						
				})
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	getMpios(key){
		fetch(Config.default.apiGateway.URL+'lookups_level2?type='+key+'&option=parents',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				for (var i = 0; i < response.length; i++) {
					response[i].names = response[i].value_name;
					response[i].id = i;
				};
				this.setState({
					mpios:response
				});
			}
		});
	}

	validSearch(){
		const fields = document.querySelector('.searching');
		const ctrls = fields.querySelectorAll('input,select');

		var is_valid = true;
		ctrls.forEach(function(ctrl, i){
			if(ctrl.value !== ""){
				if(ctrl.className.includes('error')){
					ctrl.classList.remove('error');
				}
			}else{
				
				if(!ctrl.className.includes('rbt-input-hint') && ctrl.className.length > 0){
					ctrl.classList.add('error');
					is_valid = false
				}
				
				
			}
		})

		return is_valid;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{this.state.filename}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_donors_directory"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2 searching" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
									
								<div className="form-group">
									<span className="span-min">Sexo</span>
									
									<select className="form-control" name="sex" id="sex" value={this.state.sex}
										onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="HOMBRE">HOMBRE</option>
										<option value="MUJER">MUJER</option>
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Tipo de Donantes</span>
									<select className="form-control" name="donation_type" id="donation_type" value={this.state.donation_type}
										onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.donation_types.map((don, i)=>(
											<option key={i} value={don.donation_type.id}>
												{don.lookup_value}
											</option>
										))}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Estado</span>
									<select className="form-control" name="estate" id="estate" value={this.state.estate}
										onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.states.map((s, i)=>(
			        						<option key={i} value={s.key}>{s.value_name}</option>
			        					))}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Municipio</span>
									<Typeahead
							          	labelKey={(option) => `${option.names}`}
							          	minLength={0}
							          	name="mpio"
							          	id="mpio" onKeyPress={(e) => this.props.validate(e)}
							          	inputProps={{
						          			name:"MUNICIPIO",
						          			id:"MUNICIPIO",
						          			autoComplete:'off'
						          	  	}}
						          	  	className="input_data_donor"
							          	options={this.state.mpios}
							          	onChange={this.handleChange}
							          	selected={this.state.mpioSelected}
							          	ref="_handleSearch"
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
									
								</div>
								<div className="col-xs-12 form-group" style={{paddingLeft:"0", paddingRight:"0"}}>
									<div className="col-xs-12 col-sm-6" style={{paddingLeft:"0"}}>
										<span className="span-min">Grupo</span>
										<select className="form-control" name="group" id="group" value={this.state.group}
											onChange={this.handleChange}>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.blood_types.map((s, i)=>(
				        						i % 2 === 0 ? 
								                	<option key={i}  value={s.key_group} >
								                  		{s.key_group} 
								                	</option>
								                :null
				        					))}
										</select>
									</div>
									<div className="col-xs-12 col-sm-6" style={{paddingRight:"0"}}>
										<span className="span-min">RH</span>
										<select className="form-control" name="rh" id="rh" value={this.state.rh}
											onChange={this.handleChange}>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											<option value="POSITIVO">POSITIVO</option>
											<option value="NEGATIVO">NEGATIVO</option>
										</select>
									</div>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:   <Moment format="DD/MM/YYYY">{this.state.start_date}</Moment>      
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: <Moment format="DD/MM/YYYY">{this.state.end_date}</Moment> 
										</span>
									</div>
									{/*<div className="col-xs-12">
										<a className="group-by btn btn-info" data-column="0" style={{cursor:'pointer'}}>Reordenar por Centro</a>
									</div>*/}
								</div>


								<div className="col-xs-12" id="table-to-pdf">

									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>

							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (DirectoryDonor);